module.exports = __webpack_public_path__ + "img/header-background.fad49759.jpg";